import store from '@/store'

/**
 * Handle authentication through all routes
 * Resource: https://goo.gl/MsK7bY
 */
const guardRoute = (to, from, next) => {
  // Cancell any pending API request
  Object.entries(window.cancelTokens).forEach(([requestId, cancel]) => {
    // Cancel request
    cancel()
    // Remove cancelToken from cancelTokens object
    delete window.cancelTokens[requestId]
  })

  /*
   * Check if user is authenticated
   */

  // Set user model from localStorage.token
  store.dispatch('auth/checkAuth')

  // isLoggedIn variable
  let isLoggedIn = store.getters['auth/isLoggedIn']

  // Allow Anonymous
  if (to.matched.some((record) => record.meta.allowAnonymous)) {
    next()
    // Not authenticated
  } else if (!isLoggedIn) {
    next('/login')
    // Handle "Home" redirection
  } else if (isLoggedIn && to.name === 'Home') {
    if (store.getters['auth/loggedUser'].role !== 'User') {
      next('/location')
    } else {
      next('/video')
    }
    // Authenticated and has permission to view route
  } else if (isLoggedIn && store.getters['auth/hasPermission']({
    resource: to.name
  })) {
    next()
    // Forbidden
  } else {
    next('/403')
  }
}

export default guardRoute



// WEBPACK FOOTER //
// ./src/router/guard-route.js